import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    IconButton,
    Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import CustomTable from "../../ReusableComponents/Table/CustomTable";
import { DownloadCSV } from "../../ReusableComponents/DownloadCSV";
import en_ja from "../../translations/en_ja";

const HealthAnswerStatus = ({ open, onClose, type, data }) => {
    const users =
        type === "answered"
            ? data?.userHealthAnswerDetails?.answeredUsers ?? []
            : data?.userHealthAnswerDetails?.unansweredUsers ?? [];

    const calculateAge = (birthDateStr) => {
        if (!birthDateStr) return "-";

        const year = Number(birthDateStr.slice(0, 4));
        const month = Number(birthDateStr.slice(4, 6)) - 1;
        const day = Number(birthDateStr.slice(6, 8));

        const dob = new Date(year, month, day);
        const today = new Date();

        let age = today.getFullYear() - dob.getFullYear();

        const hasHadBirthdayThisYear =
            today.getMonth() > dob.getMonth() ||
            (today.getMonth() === dob.getMonth() &&
                today.getDate() >= dob.getDate());

        if (!hasHadBirthdayThisYear) {
            age--;
        }

        return age;
    };

    const formatDate = (isoDate) => {
        if (!isoDate) return "-";

        const d = new Date(isoDate);

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const rows = users.map((u) => ({
        id: u.id,
        name: u.name || `${u.first_name || ""} ${u.last_name || ""}`,
        email: u.email || "-",
        phone: u.phone_number || "-",
        age: calculateAge(u.birth_date),
        gender:
            u.gender === "0"
                ? "Male"
                : u.gender === "1"
                    ? "Female"
                    : "-",
        created_at: formatDate(u.created_at),
    }));

    const columns = [
        { id: "name", label: en_ja["Name"] ?? "Name" },
        { id: "email", label: en_ja["Email"] ?? "Email" },
        { id: "phone", label: en_ja["Phone Number"] ?? "Phone Number" },
        { id: "age", label: en_ja["Age"] ?? "Age" },
        { id: "gender", label: en_ja["Gender"] ?? "Gender" },
        { id: "created_at", label: en_ja["Registration Date"] ?? "Registration Date" },
    ];

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>

            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight={700}>
                        {type === "answered"
                            ? en_ja["Answered Health Questions"] ??
                            "Answered Health Questions"
                            : en_ja["Not Answered Health Questions"] ??
                            "Not Answered Health Questions"}
                    </Typography>

                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box
                    mb={2}
                    display="flex"
                    justifyContent="flex-end"
                >
                    <Button
                        startIcon={<DownloadIcon />}
                        variant="contained"
                        onClick={() =>
                            DownloadCSV(columns, rows, en_ja["Health Report"])
                        }
                    >
                        {en_ja["Health Report"]}
                    </Button>
                </Box>

                <CustomTable
                    columns={columns}
                    rows={rows}
                    showIndexColumn
                />
            </DialogContent>
        </Dialog>
    );
};

export default HealthAnswerStatus;
